import styled, { css } from "styled-components";
import theme from "../../../Styles/theme";

interface ContainerProps {
  interactive?: boolean;
}
export const Container = styled.div<ContainerProps>`
 display:flex;
    flex-direction:column;
    justify-content:space-between;
    background-color:"red";
  /* ${({ interactive }) =>
    interactive &&
    css`
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    `} */
   
`;